import {
  FiMapPin,
  FiHome,
  FiCoffee,
  FiCpu,
  FiGrid,
  FiTag,
  FiLayers,
  FiSliders,
  FiArchive,
  FiBox,
  FiPackage,
  FiDollarSign,
  FiRefreshCw,
  FiGlobe,
  FiImage,
  FiDatabase,
  FiCreditCard,
  FiClipboard,
} from 'react-icons/fi';
import { crudPermissions } from '../../utils/permissions';

export const setupMenuChildren = [
  {
    id: 'setup-system',
    label: 'System',
    icon: FiCpu,
    color: 'text-blue-600',
    children: [
      { id: 'modules', label: 'Modules', path: '/setup/modules', icon: FiGrid, color: 'text-blue-600', permission: crudPermissions('modules') },
      { id: 'statuses', label: 'Statuses', path: '/setup/statuses', icon: FiTag, color: 'text-rose-600', permission: crudPermissions('settings') },
      { id: 'status-groups', label: 'Status Categories', path: '/setup/status-groups', icon: FiLayers, color: 'text-violet-600', permission: crudPermissions('settings') },
      { id: 'status-mapping', label: 'Status Mapping', path: '/setup/status-mapping', icon: FiSliders, color: 'text-cyan-600', permission: crudPermissions('settings') },
    ],
  },
  {
    id: 'setup-property',
    label: 'Property & Outlets',
    icon: FiMapPin,
    color: 'text-emerald-600',
    children: [
      { id: 'hotels', label: 'Hotels', path: '/setup/hotels', icon: FiHome, color: 'text-emerald-600', permission: crudPermissions('hotels') },
      { id: 'outlets', label: 'Outlets', path: '/setup/outlets', icon: FiCoffee, color: 'text-orange-600', permission: crudPermissions('outlets') },
      { id: 'order-types', label: 'Order Types', path: '/setup/order-types', icon: FiClipboard, color: 'text-sky-600', permission: crudPermissions('order-types') },
    ],
  },
  {
    id: 'setup-finance',
    label: 'Finance & Locale',
    icon: FiDollarSign,
    color: 'text-green-600',
    children: [
      { id: 'currencies', label: 'Currency', path: '/setup/currencies', icon: FiDollarSign, color: 'text-green-600', permission: crudPermissions('currencies') },
      { id: 'payment-methods', label: 'Payment Methods', path: '/setup/payment-methods', icon: FiCreditCard, color: 'text-emerald-600', permission: crudPermissions('payment-methods') },
      { id: 'exchange-rates', label: 'Exchange Rates', path: '/setup/exchange-rates', icon: FiRefreshCw, color: 'text-teal-600', permission: crudPermissions('exchange-rates') },
      { id: 'locales', label: 'Locales', path: '/setup/locales', icon: FiGlobe, color: 'text-indigo-600', permission: crudPermissions('settings') },
    ],
  },
  {
    id: 'setup-inventory',
    label: 'Inventory & Content',
    icon: FiDatabase,
    color: 'text-violet-600',
    children: [
      { id: 'item-category', label: 'Item Categories', path: '/setup/item-category', icon: FiArchive, color: 'text-emerald-600', permission: crudPermissions('item-categories') },
      { id: 'item', label: 'Store Items', path: '/setup/item', icon: FiBox, color: 'text-amber-600', permission: crudPermissions('items') },
      { id: 'unit', label: 'Units', path: '/setup/unit', icon: FiPackage, color: 'text-cyan-600', permission: crudPermissions('units') },
      { id: 'store', label: 'Stores', path: '/setup/store', icon: FiHome, color: 'text-violet-600', permission: crudPermissions('stores') },
      { id: 'slideshow-slides', label: 'Slideshow', path: '/setup/slideshow-slides', icon: FiImage, color: 'text-pink-600', permission: crudPermissions('slideshow-slides') },
    ],
  },
];

export const setupRoutes = [
  { path: 'setup/hotels', component: 'Hotel' },
  { path: 'setup/outlets', component: 'Outlet' },
  { path: 'setup/order-types', component: 'OrderType' },
  { path: 'setup/modules', component: 'Module' },
  { path: 'setup/statuses', component: 'Statuses' },
  { path: 'setup/status-groups', component: 'StatusGroups' },
  { path: 'setup/status-mapping', component: 'StatusMapping' },
  { path: 'setup/item-category', component: 'ItemCategory' },
  { path: 'setup/menu-items', component: 'MenuItem' },
  { path: 'setup/menu-categories', component: 'MenuCategories' },
  { path: 'setup/menu-subcategories', component: 'MenuSubcategories' },
  { path: 'setup/item', component: 'Item' },
  { path: 'setup/unit', component: 'Unit' },
  { path: 'setup/currencies', component: 'Currency' },
  { path: 'setup/payment-methods', component: 'PaymentMethod' },
  { path: 'setup/exchange-rates', component: 'ExchangeRate' },
  { path: 'setup/locales', component: 'Locale' },
  { path: 'setup/slideshow-slides', component: 'SlideshowSlides' },
  { path: 'setup/store', component: 'Store' },
];
